import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { ResponsableHierarchiqueDto } from "../../../dto/GenApi.iNotPaie.Dto/ResponsableHierarchiqueDto";
import { SalarieContratDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieContratDto";
import { SalarieContratHistoriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieContratHistoriqueDto";
import { SalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { ScenariosDto } from "../../../dto/GenApi.iNotPaie.Dto/ScenariosDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { EventBus } from "../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import ModalHoraireHebdo from "../../modalComponents/modalHoraireHebdo/modalHoraireHebdo";

interface salarieChargeInfos {
    errorMessage: string[];
    isModified: boolean;
    salarieCourant?: SalarieContratDto;
    contratsHistorique: SalarieContratHistoriqueDto[];
    proprietePrincipalesChanged: boolean
}

@Component({
    components: {
        ListeRubriquesSalarieComponent: require("../listeRubriques/listeRubriquesSalarie.vue.html"),
        ModalHoraireHebdo: require("../../modalComponents/modalHoraireHebdo/modalHoraireHebdo.vue.html")
    }
})
export default class ContratSalarieComponent extends Vue {
    public currentId = 0;
    public dataReady = false;
    public isModified = false;
    public isModDemarrage = false;
    public errorMessage: string[] = [];
    public salarieCharges: salarieChargeInfos[] = [];
    public salarieCourant?: SalarieContratDto;
    public listeResponsablesHierarchiques: ResponsableHierarchiqueDto[] = [];
    public listeResponsablesHierarchiquesFiltres: ResponsableHierarchiqueDto[] = [];
    public listeSalarieEnCours: SalarieDto[] = [];
    public contratsHistorique: SalarieContratHistoriqueDto[] = [];
    public proprietePrincipalesChanged = false;

    //* * Les listes des combos **//
    public listeNatureContrats: ParametreDto[] = [];
    public listeTypeContrats: ParametreDto[] = [];
    public listeRemunerations: ParametreDto[] = [];
    public listeMaladieRetraites: ParametreDto[] = [];
    public listeTransports: ParametreDto[] = [];
    public listeGestionConges: ParametreDto[] = [];
    public listeCaisseComplementaires: ParametreDto[] = [];
    public listeMotifRecours: ParametreDto[] = [];
    public listeServices: ParametreDto[] = [];
    public listeHandicapes: ParametreDto[] = [];
    public listeDiplomesPrepares: ParametreDto[] = [];
    public listeScenarios: ScenariosDto[] = [];
    public tempsPartielCotisantTempsPleins: ParametreDto[] = [];

    public isInitialized = false;
    public canModify = false;
    public ifModeCongeActive = true;

    public reloadData(id: number): void {
        if (this.currentId > 0) {
            this.salarieCharges[this.currentId] = {
                contratsHistorique: this.contratsHistorique,
                errorMessage: this.errorMessage,
                isModified: this.isModified,
                salarieCourant: this.salarieCourant,
                proprietePrincipalesChanged: this.proprietePrincipalesChanged
            };
        }
        this.currentId = id;
        this.fetchData();
    }

    public refreshContrat(): void {
        this.fetchData();
    }

    public modifyTypeDeContrat(): void {
        if (this.salarieCourant != undefined) {
            this.salarieCourant.ExonerationCsg = this.salarieCourant.CodeTypeContrat == "APP";
        }
        this.modifyInfoCsg();
        this.modifyPropertiesPrincipales();
    }

    public modifyPropertiesPrincipales(): void {
        this.proprietePrincipalesChanged = true && this.salarieCourant != undefined && this.salarieCourant.ContratActif;
        this.modifyForRubriques();
    }

    public modifyForRubriques(): void {
        this.modify();
        this.$children.forEach(c => {
            const child: any = c;
            if (child.refreshRubriquesVisibleContrat != undefined) {
                child.refreshRubriquesVisibleContrat();
            }
        });
    }

    public modifyCaisseComplementaire(codeCaisseComplementaire?: string): void {
        this.modify();
        this.$children.forEach(c => {
            const child: any = c;
            if (child.refreshRubriquesVisibleContrat != undefined) {
                let caisse: ParametreDto | undefined;
                if (codeCaisseComplementaire != undefined) {
                    const caissesComplementaires = this.listeCaisseComplementaires.filter(c => c.Code == codeCaisseComplementaire);
                    if (caissesComplementaires != undefined && caissesComplementaires[0] != undefined) {
                        caisse = caissesComplementaires[0];
                    }
                }
                child.refreshRubriquesVisibleContrat(caisse);
            }
        });
    }

    public init(): void {
        if (this.isInitialized || ParametresInstance.utilisateurCourant == undefined || ParametresInstance.societeCourante == undefined) {
            return;
        }

        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) && this.salarieCourant != undefined && this.salarieCourant.IsCurrent;
        this.ifModeCongeActive = ParametresInstance.societeCourante.IsModeCongeActive;

        this.initConstantes();

        this.isInitialized = true;
    }

    public mounted(): void {
        this.isInitialized = false;

        // On ne sait pas dans quel ordre ça peut arriver (1er appel ou refresh de la page...)
        EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
            this.init();
        });

        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
        });
        this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);

        this.init();
    }

    public resetData(id: number): void {
        if (this.salarieCharges[id] != undefined) {
            this.salarieCharges[id].isModified = false;
        }
        if (this.currentId == id) {
            this.fetchData();
        }
    }

    public initConstantes(): void {
        ServicesFactoryInstance.ParametresService.getNatureContrats(data => {
            this.listeNatureContrats = data;
        });
        ServicesFactoryInstance.ParametresService.getTypeContrats(data => {
            this.listeTypeContrats = data;
        });
        ServicesFactoryInstance.ParametresService.getMaladieRetraites(data => {
            let listeMaladieRetraites = data;
            if (ParametresInstance.estSocieteAlsaceMoselle() || ParametresInstance.estSocieteDomTom()) {
                listeMaladieRetraites = listeMaladieRetraites.filter(regime => regime.Code != "CRPUR");
            }

            this.listeMaladieRetraites = listeMaladieRetraites;
        });
        ServicesFactoryInstance.ParametresService.getRemunerations(data => {
            this.listeRemunerations = data;
        });
        ServicesFactoryInstance.ParametresService.getTransports(data => {
            this.listeTransports = data;
        });
        ServicesFactoryInstance.ParametresService.getGestionConges(data => {
            this.listeGestionConges = data;
        });
        ServicesFactoryInstance.ParametresService.getCaisseComplementaires(data => {
            this.listeCaisseComplementaires = data;
        });
        ServicesFactoryInstance.ParametresService.getMotifRecours(data => {
            this.listeMotifRecours = data;
        });
        ServicesFactoryInstance.ParametresService.getServices(data => {
            this.listeServices = data;
        });
        ServicesFactoryInstance.ParametresService.getHandicapes(data => {
            this.listeHandicapes = data;
        });
        ServicesFactoryInstance.ParametresService.getDiplomesPrepares(data => {
            this.listeDiplomesPrepares = data;
        });
        ServicesFactoryInstance.ScenariosService.getScenariosByNat("S", (data) => {
            this.listeScenarios = data.filter(s => s.CodeTypeScenario == "ORGAN");
        });

        ServicesFactoryInstance.ParametresService.getTempsPartielCotisantTempsPleins(data => {
            this.tempsPartielCotisantTempsPleins = data;
        });
    }

    public fetchData(): void {
        if (this.currentId < 1) {
            return;
        }

        this.dataReady = false;
        if (this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
            if (isNaN(Number(this.$route.query.idContrat))) {
                ServicesFactoryInstance.SalarieService.getSalarieQualification(this.currentId, this.setData, () => this.dataReady = true);
            } else {
                ServicesFactoryInstance.SalarieService.getSalarieQualificationForContrat(this.currentId, Number(this.$route.query.idContrat), this.setData, () => this.dataReady = true);
            }
        } else {
            this.isModified = this.salarieCharges[this.currentId].isModified;
            this.errorMessage = this.salarieCharges[this.currentId].errorMessage;
            this.salarieCourant = this.salarieCharges[this.currentId].salarieCourant;
            this.contratsHistorique = this.salarieCharges[this.currentId].contratsHistorique;
            this.proprietePrincipalesChanged = this.salarieCharges[this.currentId].proprietePrincipalesChanged;
            this.setData(this.salarieCourant);
        }
    }

    public setData(data?: SalarieContratDto): void {
        if (data == undefined || data.IdSalarie != this.currentId) {
            return;
        }

        this.salarieCourant = data;

        ServicesFactoryInstance.SalarieService.getListeResponsablesHierarchiques(data => {
            this.listeResponsablesHierarchiques = data;
            this.listeResponsablesHierarchiquesFiltres = this.listeResponsablesHierarchiques.filter(d => d.IdSalarie != this.currentId).sort((a, b) => `${a.Nom} ${a.Prenom}` > `${b.Nom} ${b.Prenom}` ? 1 : -1);
        }, () => {
            this.listeResponsablesHierarchiques = [];
            this.listeResponsablesHierarchiquesFiltres = [];
        });

        ServicesFactoryInstance.SalarieService.getSalariesEnCours(data => {
            this.listeSalarieEnCours = data;
        }, () => {
            this.listeSalarieEnCours = [];
        });

        if (this.salarieCourant && this.salarieCourant.IdContrat == 0) {
            this.isModified = true;
            this.salarieCourant.RubriqueContrats = [];
        }
        this.contratsHistorique = [];

        ServicesFactoryInstance.SalarieService.getSalarieContratHistorique(this.currentId, data => {
            this.contratsHistorique = data;
            this.contratsHistorique.sort((a, b) => a.DateDebut != undefined && b.DateDebut != undefined && a.DateDebut > b.DateDebut ? -1 : 1);
        });

        this.proprietePrincipalesChanged = false;

        this.dataReady = true;
        this.$forceUpdate();

        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) && this.salarieCourant != undefined && this.salarieCourant.IsCurrent;
    }

    public deleteContrat(idContrat: any): void {
        const modalAlerteAvecCallback: ModalAlerteOptions = new ModalAlerteOptions(
            {
                message: "Souhaitez-vous vraiment supprimer ce contrat ?",
                callBackYes: () => {
                    this.dataReady = false;
                    NotificationServiceInstance.SendSuccess("Suppression du contrat");
                    ServicesFactoryInstance.SalarieService.deleteContrat(idContrat, () => {
                        ServicesFactoryInstance.SalarieService.getSalarieContratHistorique(this.currentId, data => {
                            this.contratsHistorique = data;
                            this.contratsHistorique.sort((a, b) => a.DateDebut != undefined && b.DateDebut != undefined && a.DateDebut > b.DateDebut ? -1 : 1);
                            this.dataReady = true;
                        });

                        NotificationServiceInstance.SendSuccess("La suppression du contrat s'est correctement déroulée !");
                    }, () => {
                        this.dataReady = true;
                    });
                },
                canClose: true,
                showDialog: true,
                title: "Suppression du contrat"
            });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteAvecCallback);
    }

    public enregistrer(): boolean {
        if (this.salarieCourant == undefined) {
            return false;
        }

        this.errorMessage = [];
        // TODO régles de validations complèxes

        if (this.errorMessage.length > 0) {
            alert("Enregistrement impossible, des erreurs de saisie sont présentes");

            return false;
        }

        if (this.proprietePrincipalesChanged) {
            const modalAlerteAvecCallback: ModalAlerteOptions = new ModalAlerteOptions(
                {
                    message: "Vous avez effectué une modification du contrat impliquant un changement dans la DSN. Souhaitez-vous vraiment valider votre modification ?",
                    callBackYes: () => {
                        this.proprietePrincipalesChanged = false;
                        this.enregistrer();
                    },
                    canClose: true,
                    showDialog: true,
                    title: "Modification du contrat"
                });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteAvecCallback);

            return false;
        }

        this.$children.forEach(c => {
            const child: any = c;
            if (child.updateSalarie != undefined) {
                child.updateSalarie();
            }
        });

        if ((this.salarieCourant.CodeSociete == undefined || this.salarieCourant.CodeSociete == "") && ParametresInstance.societeCourante != undefined) {
            this.salarieCourant.CodeSociete = ParametresInstance.societeCourante.Code;
        }

        this.dataReady = false;
        ServicesFactoryInstance.SalarieService.updateSalarieContrat(this.salarieCourant, data => {
            this.setData(data);
            this.$emit("isModified", false);
            this.$emit("contratUpdated");
            this.isModified = false;
            NotificationServiceInstance.SendSuccess("L'enregistrement du salarié s'est correctement déroulé !");
        }, () => {
            this.dataReady = true;
        });

        return false;
    }

    public modifyResponsableHierarchique(): void {
        this.modify();
    }

    public modifyAssistantDeGestion(): void {
        this.modify();
    }

    public modifyTreiziemeMois(): void {
        if (this.salarieCourant != undefined && !this.salarieCourant.TreiziemeMois) {
            this.salarieCourant.EstTreiziemeMoisMensualise = false;
        }
        this.modifyForRubriques();
    }

    public annuler(): void {
        if (this.salarieCharges[this.currentId] != undefined) {
            this.salarieCharges[this.currentId].isModified = false;
        }
        this.fetchData();
        this.isModified = false;
        this.$emit("isModified", false);
    }

    public modify(): void {
        this.$emit("isModified", true);
        this.isModified = false;
        this.isModified = true;
    }

    public viewDetails(contrat: SalarieContratHistoriqueDto): void {
        if (this.salarieCourant == undefined || contrat.IdContrat == undefined) {
            return;
        }

        const idContrat = contrat.IdContrat.toString();

        this.isModified = false;
        this.$emit("contratHistoriqueUpdated");
        EventBus.NavigateTo({
            path: "/ficheSalarie/" + contrat.IdSalarie,
            query: { titre: "Historique contrat N° " + contrat.NumeroSalarie, idContrat: idContrat }
        });
    }

    public horaireHebdo(): void {
        if (this.salarieCourant?.IdContrat === undefined) {
            return;
        }
        const modalHoraireHebdo = this.$refs.modalHoraireHebdo as ModalHoraireHebdo;
        modalHoraireHebdo.initContratSalarie(this.salarieCourant?.IdContrat ?? 0);
    }

    public onHoraireHebdoContratUpdated(idContrat: number, idHoraireHebdo: number): void {
        if (this.salarieCourant === null || this.salarieCourant === undefined || this.salarieCourant.IdContrat != idContrat) {
            return;
        }

        this.salarieCourant.IdHoraireHebdo = idHoraireHebdo;
    }

    public modifyInfoCsg(): void {
        this.$children.forEach(c => {
            const child: any = c;
            if (child.setInfoCsg != undefined) {
                child.setInfoCsg(this.salarieCourant?.DateDebut);
            }
        });
    }

    public isCsgApprentiActive() {
        if (this.salarieCourant != undefined) {
            return !this.canModify || this.salarieCourant.CodeTypeContrat != 'APP' || this.salarieCourant.ExonerationCsg == false;
        }
        else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/contratSalarie/contratSalarie.ts